<script setup lang="ts">
import data from '@/common/data/methodology/data';
import ArticleAttribution from '@/components/article-attribution/ArticleAttribution.vue';
import Author from '@/components/author/AuthorDetails.vue';
import PageContent from '@/components/page-content/PageContent.vue';
import StandardPage from '@/content-types/standard-page/StandardPage.vue';
import { useSeoMeta } from '#app';

useSeoMeta({
  title: 'Methodology | Open Methane',
  ogTitle: 'Methodology | Open Methane',
  description: 'How Open Methane uses public data and satellite measurements to estimate Australia\'s methane emissions.',
  ogDescription: 'How Open Methane uses public data and satellite measurements to estimate Australia\'s methane emissions.',
});
</script>

<template>
  <StandardPage
    title="Methodology"
    img="/img/methodology-header.png"
  >
    <ArticleAttribution>
      <Author
        title="Science Lead"
        name="Professor Peter Rayner"
        image="/img/peter-300px.png"
      />
    </ArticleAttribution>
    <PageContent :page-data="data" />
  </StandardPage>
</template>
